/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React, { useState, useEffect } from "react";
import { Card } from "@material-ui/core";
import { ExternalContactsTable } from "./ExternalContactsTable";
import { useExternalContacts } from "../../context/externalContacts";
import { ExternalContactEdit, ExternalContactsActionsHeader } from ".";
import { ConfirmDialog } from "../../../../components/ConfirmDialog/ConfirmDialog";
import { ProgressOverlay } from "../../../../components/Common";
import { EmptyPlaceholder } from "../../../../components";

/**
 * Component used to manage external contacts
 */
export const ExternalContacts = () => {
	const [isLoading, setIsLoading] = useState(false);
	const { fetchContacts, contacts, fetchRemoteConfig, contactsLoading, deleteModal, isEditingContact } =
		useExternalContacts();

	useEffect(() => {
		fetchContacts();
	}, [fetchContacts]);

	useEffect(() => {
		fetchRemoteConfig();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Card>
			<div style={{ position: "relative", minHeight: 300, display: "flex", flexDirection: "column" }}>
				{isLoading && <ProgressOverlay />}
				{contactsLoading ? (
					<ProgressOverlay />
				) : !contacts ? (
					<EmptyPlaceholder message="Failed to load external contacts, please try again." />
				) : (
					<>
						<div className="my-3">
							<ExternalContactEdit isLoading={isLoading} setIsLoading={setIsLoading} isOpen={isEditingContact} />
							<ConfirmDialog {...deleteModal} />
							<div className="px-3">
								<ExternalContactsActionsHeader />
							</div>
							<div className="mt-3">
								<ExternalContactsTable isLoading={isLoading} setIsLoading={setIsLoading} />
							</div>
						</div>
					</>
				)}
			</div>
		</Card>
	);
};
